import { postRoute } from "../client"
export const roomJoinRoute = postRoute<{ success: boolean; error?: string; presenceId?: string; roomId?: string }>("/api/rooms/join")
